import { Box, Grid, Typography } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const preGranteesOverview =`Dear Colleague

The pre-grant status is an in between, temporary phase. It refers to proposals which were approved for funding by GIF's Board of Governors,
however, the researchers involved did not yet conclude submitting to the GIF the mandatory documents.
When all the PI's from all institutions involved in a given Grant will submit the mandatory documents the Pre-Grant status will be changed to Grant.

You can see here all researchers from your institution who are under this category, i.e. were approved by the GIF Board of Governors, however,
did not yet submit all mandatory documents and/-or not yet processed by GIF. Usually, by December 15th all pre grants become Grants.

In addition to the list of pre grantees, we prepared some more tools: Notes and a dialogue box.
For your convenience you may use the Notes. In here you can write comments to yourself.

A dialogue box allowing you to write short messages to the GIF and vice versa.
Obviously this does not replace the regular communications by emails and telephone calls BUT it serves as an additional real time communication with the GIF.

We hope you will find this useful and user friendly.

As always, when ever needed, do not hesitate to contact us at: finance@gif.org.il.

Thank you for your cooperation,

GIF Team`


const useStyles = makeStyles((theme) => ({
  infoIcon: {
    marginLeft: 5,
  },
  header: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
}));


export default function Overview() {
  const classes = useStyles();

  return (
    <Grid container>
    <Grid item xs={12}>
      <Box className={classes.header}>
        <Typography variant="subtitle2">Pre Grant Overview</Typography>
        <InfoOutlinedIcon className={classes.infoIcon} color="primary" />
      </Box>
    </Grid>
    <Grid item xs={12}>
      <pre style={{ fontFamily: "inherit", fontSize: 14 }}>
        {preGranteesOverview}
      </pre>
    </Grid>
    </Grid>
  );
}
